module.exports = __webpack_public_path__ + "static/img/jacket_green.0cf1104d.png";